import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import FindInvoiceComponent from './find-invoice.component';

let FindInvoiceModule = angular
  .module('FindInvoice', [
    uiRouter
  ])
  .component('findInvoice', FindInvoiceComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('findInvoice', {
      url: '/find-invoice',
      data: {
        authRequired: true,
        permsRequired: ['account-bills']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'findInvoice'
        }
      }
    })
  })
  .name;

export default FindInvoiceModule;



// WEBPACK FOOTER //
// ./src/app/pages/find-invoice/find-invoice.module.js